import type { Location } from '@/shared/types/location'

export const formatFullAddress = (location: Location) => {
  const parts = [
    location.road_name,
    location.town,
    location.county,
    location.postcode,
  ].filter((part): part is string => Boolean(part?.trim()))

  return parts.join(', ')
}
